module.exports = __webpack_public_path__ + "img/image-talent-zeigen.3c28b99f.jpg";